/* CARELIKA · Amber landing — language-neutral script.
   Loaded by every amber-* section; runs once, and re-initialises
   when the theme editor re-renders a section. */
(function(){
  if (window.__amberLp){ window.__amberLp.init(); return; }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- mobile section navigation ---- */
  function navOpen(v){
    var navSheet = document.getElementById('navSheet');
    var navBtn = document.getElementById('navBtn');
    if(!navSheet || !navBtn) return;
    navSheet.hidden = !v;
    navBtn.setAttribute('aria-expanded', v ? 'true' : 'false');
    document.documentElement.style.overflow = v ? 'hidden' : '';
  }
  document.addEventListener('click', function(e){
    var t = e.target;
    if(!t || !t.closest) return;
    if(t.closest('#navBtn')){
      var sheet = document.getElementById('navSheet');
      navOpen(sheet ? sheet.hidden : false);
      return;
    }
    if(t.closest('#navClose')){ navOpen(false); return; }
    var inSheet = t.closest('#navSheet');
    if(inSheet && (t === inSheet || t.closest('a'))){ navOpen(false); }
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ navOpen(false); } });

  /* ---- analytics events (GA4 / GTM via dataLayer) ---- */
  function track(name, extra){
    try{
      window.dataLayer = window.dataLayer || [];
      var o = {event: name};
      if(extra){ for(var k in extra){ if(Object.prototype.hasOwnProperty.call(extra,k)){ o[k] = extra[k]; } } }
      window.dataLayer.push(o);
    }catch(err){}
  }
  function label(el){ return (el.textContent || '').replace(/\s+/g,' ').trim().slice(0,48); }
  document.addEventListener('click', function(e){
    if(!e.target.closest) return;
    var el = e.target.closest('.amber-lp [data-apply],.amber-lp [data-materials]');
    if(el){
      track(el.hasAttribute('data-materials') ? 'lead_materials_click' : 'lead_apply_click', {cta_text: label(el)});
    }
    var w = e.target.closest('.amber-lp [data-wa]');
    if(w){ track('lead_whatsapp_click', {cta_text: label(w)}); }
  });
  document.addEventListener('submit', function(e){
    if(e.target && e.target.closest && e.target.closest('.amber-lp')){ track('lead_form_submit'); }
  }, true);
  var marks = {25:false, 50:false, 75:false, 100:false};
  window.addEventListener('scroll', function(){
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if(h <= 0) return;
    var p = Math.round(window.scrollY / h * 100);
    for(var key in marks){
      if(!marks[key] && p >= Number(key)){ marks[key] = true; track('scroll_depth', {percent: Number(key)}); }
    }
  }, {passive:true});

  /* ---- sticky apply bar ---- */
  function syncSticky(){
    var bar = document.getElementById('sticky'),
        hero = document.querySelector('.amber-lp .hero'),
        apply = document.getElementById('apply');
    if(!bar || !hero) return;
    var pastHero = window.scrollY > hero.offsetHeight * 0.75;
    var atForm = apply && apply.getBoundingClientRect().top < window.innerHeight * 0.9;
    bar.classList.toggle('on', pastHero && !atForm);
  }
  window.addEventListener('scroll', syncSticky, {passive: true});
  window.addEventListener('resize', syncSticky);

  /* ---- reveal on scroll ---- */
  var io = null;
  if(!reduce && 'IntersectionObserver' in window){
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, {rootMargin: '0px 0px -8% 0px', threshold: 0.05});
  }
  function initReveal(){
    var rv = document.querySelectorAll('.amber-lp .rv:not(.in)');
    for(var j = 0; j < rv.length; j++){
      if(rv[j].__amberRv) continue;
      rv[j].__amberRv = true;
      if(io){ io.observe(rv[j]); } else { rv[j].classList.add('in'); }
    }
  }

  /* ---- before / after slider ---- */
  function initSlider(){
    var range = document.getElementById('baRange'),
        before = document.getElementById('baBefore'),
        handle = document.getElementById('baHandle');
    if(!range || !before || !handle || range.__amberBa) return;
    range.__amberBa = true;
    var setPos = function(v){
      before.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
      handle.style.left = v + '%';
    };
    range.addEventListener('input', function(){ setPos(this.value); });
    setPos(range.value);
  }

  /* ---- CO2 fizz in the hero ---- */
  function initFizz(){
    var c = document.getElementById('fizz');
    if(!c || reduce || c.__amberFizz) return;
    c.__amberFizz = true;
    var ctx = c.getContext('2d'), parts = [], W = 0, H = 0,
        dpr = Math.min(window.devicePixelRatio || 1, 2);
    var size = function(){
      W = c.clientWidth; H = c.clientHeight;
      c.width = W * dpr; c.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    var seed = function(){
      parts = [];
      var n = Math.round(W / 46);
      for(var i = 0; i < n; i++){
        parts.push({
          x: Math.random() * W,
          y: Math.random() * H,
          r: 5 + Math.random() * 15,
          v: 0.12 + Math.random() * 0.5,
          d: (Math.random() - 0.5) * 0.3,
          a: 0.22 + Math.random() * 0.4,
          warm: Math.random() < 0.35
        });
      }
    };
    var tick = function(){
      if(!c.isConnected) return;               /* section was re-rendered in the editor */
      ctx.clearRect(0, 0, W, H);
      for(var i = 0; i < parts.length; i++){
        var p = parts[i];
        p.y -= p.v;
        p.x += Math.sin(p.y / 40) * p.d;
        if(p.y + p.r < 0){ p.y = H + p.r; p.x = Math.random() * W; }
        ctx.globalAlpha = p.a;
        ctx.strokeStyle = p.warm ? '#F49023' : '#8FCFDF';
        ctx.lineWidth = 1.4;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
      requestAnimationFrame(tick);
    };
    size(); seed(); tick();
    var t;
    window.addEventListener('resize', function(){
      if(!c.isConnected) return;
      clearTimeout(t);
      t = setTimeout(function(){ size(); seed(); }, 180);
    });
  }

  /* ---- "thank you" after a form sent through FormSubmit (returns with ?amber_sent=...) ---- */
  function initSent(){
    var m = /[?&]amber_sent=([a-z]+)/.exec(window.location.search);
    if(!m) return;
    var ok = document.querySelector('.amber-lp [data-amber-ok="' + m[1] + '"]');
    if(ok){ ok.style.display = ''; }
  }

  function init(){
    initSent();
    initReveal();
    initSlider();
    initFizz();
    syncSticky();
  }

  window.__amberLp = {init: init};
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* theme editor: a section was added, edited or re-ordered */
  document.addEventListener('shopify:section:load', init);
})();
